<div class="row">
  <div class='col-lg-6 info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <div class='info-list-2'>

          <info-list-item label='Name' labelTooltip="The business name of the app's developer."
            (valueInteract)="_userService.ottDiscoveryEnabled() ? toAppDiscoveryClick({param: 'developerName', paramValue : developerOverview?.name}) : null"
            [value]='developerOverview?.name'></info-list-item>

          <info-list-item label='Website'
            [link]='developerOverview?.website !== "N/A" ? developerOverview?.website : null'
            [value]='developerOverview?.website === "N/A" ? "N/A" : "Go to Website"'></info-list-item>

          <info-list-item label='Total Apps' labelTooltip='The total number apps available from the developer.'
            [lock]='isFreemium && !isFollowing' [value]='developerOverview?.totalApps'></info-list-item>

        </div>
      </div>
    </div>
  </div>
  <div class='col-lg-6 info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <div class='info-list-2'>
          <div class="divider d-lg-none"></div>

          <info-list-item label='WHOIS Info Hidden'
            labelTooltip='Businesses with privately registered anonymous domains are flagged as high risk.'
            valueIcon='/assets/images/icon-indicator-{{developerOverview?.isPrivateDomain | yesno:"rev"}}-2.svg'
            [value]='developerOverview?.isPrivateDomain | yesno:"capitalize"'></info-list-item>

          <info-list-item [show]='isFreemium || developerOverview?.hasTermsOfServiceLink !== "N/A"'
            label='Terms and Conditions'
            labelTooltip='Businesses without published terms and conditions on their website are flagged as high risk to advertisers and sellers.'
            [lock]='isFreemium && !isFollowing'
            valueIcon='/assets/images/icon-indicator-{{developerOverview?.hasTermsOfServiceLink | yesno}}-2.svg'
            [value]='developerOverview?.hasTermsOfServiceLink | yesno:"capitalize"'></info-list-item>

          <info-list-item [show]='isFreemium || developerOverview?.hasPrivacyLink !== "N/A"' label='Privacy Policy'
            labelTooltip="Indicates the presence of a privacy policy on the app's publisher or developer website. Businesses without a privacy policy on their website are flagged as high risk to advertisers and sellers."
            [lock]='isFreemium && !isFollowing'
            valueIcon='/assets/images/icon-indicator-{{developerOverview?.hasPrivacyLink | yesno}}-2.svg'
            [value]='developerOverview?.hasPrivacyLink | yesno:"capitalize"'></info-list-item>

        </div>
      </div>
    </div>
  </div>
</div>
<app-follow-unlock label="Additional Developer Details" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
</app-follow-unlock>
